import i18n from '@i18next/i18n';
import LINE_ARROW_DOWN_ICON from '@tencent/docs-design-resources/icon/desktop/svg/liner_arrow_down_24.svg';
import Tooltip from '@tencent/dui/lib/components/Tooltip';
import React, { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import Style from '../index.less';
import classNames from 'classnames';
import { EventCodeType, TDWActionType, TDWModuleType, TDWOperationType } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import Close from '@com/animation-editor/images/close.svg';

interface ICommentDrawerTitleProps {
    isJumpBtnDisabled?: boolean;
    jumpToPrevComment(): void;
    jumpToNextComment(): void;
    onClose(): void;
}

export const CommentDrawerTitle = (props: ICommentDrawerTitleProps, ref: any) => {
    const commentDrawerTitleRef = useRef<any>();
    const [isJumpBtnDisabled, setIsJumpBtnDisabled] = useState(props.isJumpBtnDisabled);

    useImperativeHandle(ref, () => ({
        updateBtnState,
    }));

    const updateBtnState = ({ isJumpBtnDisabled }) => {
        if (typeof isJumpBtnDisabled !== 'undefined') {
            setIsJumpBtnDisabled(isJumpBtnDisabled);
        }
    };

    const jumpToPrevComment = () => {
        props.jumpToPrevComment();
        report(TDWActionType.LAST_COMMENT, EventCodeType.DOC_PPT_COMMENTS_SLIDEBAR_LAST_COMMENT);
    };

    const jumpToNextComment = () => {
        props.jumpToNextComment();
        report(TDWActionType.NEXT_COMMENT, EventCodeType.DOC_PPT_COMMENTS_SLIDEBAR_NEXT_COMMENT);
    };

    const report = (action, eventcode) => {
        tdw({
            opername: TDWOperationType.DOC_PPT,
            module: TDWModuleType.COMMENTS_SLIDEBAR,
            action,
            eventcode,
        });
    };

    const btnClass = classNames({
        [Style['comment-btn']]: true,
        [Style['comment-btn-disabled']]: isJumpBtnDisabled,
    });
    return <div className={Style['comment-drawer-title']} ref={commentDrawerTitleRef}>
        <div className={Style['title-content']}>
            <span className={Style['title-text']}>{i18n.t('批注')}</span>
            <Tooltip title={i18n.t('上一条')}>
                <img src={LINE_ARROW_DOWN_ICON} alt='' className={btnClass} style={{ transform: 'rotate(180deg)' }}
                    onClick={jumpToPrevComment}></img>
            </Tooltip>
            <Tooltip title={i18n.t('下一条')}>
                <img src={LINE_ARROW_DOWN_ICON} alt='' className={btnClass} onClick={jumpToNextComment}></img>
            </Tooltip>
        </div>
        <img className={Style['close-button']} src={Close}
            onClick={() => props.onClose()}/>
    </div>;
};

export default forwardRef(CommentDrawerTitle);
